var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagin"},[_c('el-pagination',{staticStyle:{"padding-top":"20px","text-align":"right"},attrs:{"layout":"prev, pager, next","background":"","page-size":_vm.queryParams.pageSize,"total":_vm.queryParams.total},on:{"current-change":_vm.changePage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }